import { Divider, Tab, Tabs } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import "moment/locale/id";
import React, { useCallback, useEffect, useState } from "react";
import Spinner from "../../components/Spinner/Spinner";
import TokoTidakAktif from "../../components/TokoTidakAktif/TokoTidakAktif";
import {
    ParamsGetListShift,
    ParamsGetListTransactionShift,
    ParamsGetShiftNow
} from "../../constants/types";
import { useAuth } from "../../context/authContext";
import useTimeAlt from "../../services/queries/useTimeAlt";
import useUkm from "../../services/queries/useUkm";
import useUser from "../../services/queries/useUser";
import { getLocalUkmId, setLocalUkmId } from "../../utils/handleChangeUkmId";
import scrollToHash from "../../utils/scrollToHash";

import {
    mdiCash
} from "@mdi/js";
import Icon from "@mdi/react";
import { Typography } from "@mui/material";
import Swal from "sweetalert2";
import CardLaporanShift from "../../components/CardLaporanShift/CardLaporanShift";
import CardShift from "../../components/CardShift/CardShift";
import { textPrimary } from "../../constants/colors";
import toRupiah from "../../utils/toRupiah";

import { LoadingButton } from "@mui/lab";
import { InputAdornment } from "@mui/material";
import Card from "@mui/material/Card";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import DatePicker from "react-datepicker";
import NumberFormat from "react-number-format";
import useListShift from "../../services/queries/useListShift";
import useListTransactionShift from "../../services/queries/useListTransactionShift";
import useShiftNow from "../../services/queries/useShiftNow";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ModalEndShift from "../../components/ModalEndShift/ModalEndShift";
import axios from "../../services/axios";



moment.locales();
moment.locale("id");

type DateFilter = [Date | null, Date | null];

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

function hexToRgb(hex: string | undefined): string {
    if (!hex) return '255, 255, 255';
    
    hex = hex.replace(/^#/, '');
    
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    
    const num = parseInt(hex, 16);
    const r = (num >> 16) & 255;
    const g = (num >> 8) & 255;
    const b = num & 255;
    
    return `${r}, ${g}, ${b}`;
}

const Shifting = () => {
    const { ukmIdUser } = useAuth();
    const { data: user, status: statusUser } = useUser();
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));
    const isLaptopScreen = useMediaQuery(theme.breakpoints.up("lg"));
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    const moment = require("moment");
    let now = moment().format("DD MMMM YYYY");
    let nowShift = moment().format("YYYY-MM-DD");

    const [dateRange, setDateRange] = useState<DateFilter>([
        new Date(),
        new Date(),
    ]);
    const [startDate, endDate] = dateRange;

    const [isOpenModalEndShift, setIsOpenModalEndShift] =
        useState(false);

    const closeModalEndShift = useCallback(() => {
        setIsOpenModalEndShift(false);
    }, []);

    // SHIFT NOW

    const paramsShiftNow: ParamsGetShiftNow = {
        ukmId: ukmIdUser && ukmIdUser[0],
        tipe: "now",
    };

    const {
        data: shiftNow,
        refetch: refetchShiftNow,
    } = useShiftNow(paramsShiftNow);

    // LIST SHIFT

    const initialParamsGetListShift = {
        ukmId: ukmIdUser && ukmIdUser[0],
        size: 100,
        page: 1,
        tglAwal: nowShift,
        tglAkhir: nowShift,
    };

    const [paramsListShift, setParamsListShift] =
        useState<ParamsGetListShift>(initialParamsGetListShift);

    const {
        data: listShift,
        refetch: refetchListShift,
    } = useListShift(paramsListShift);

    // LIST TRANSACTION SHIFT

    const initialParamsGetListTransactionShift = {
        ukmId: ukmIdUser && ukmIdUser[0],
        shiftId: 0,
    };    

    const [paramsListTransactionShift, setParamsListTransactionShift] =
        useState<ParamsGetListTransactionShift>(initialParamsGetListTransactionShift);

    const {
        data: listTransactionShift,
    } = useListTransactionShift(paramsListTransactionShift);

    useEffect(() => {
        if (shiftNow?.id) {
            setParamsListTransactionShift({
                ukmId: ukmIdUser && ukmIdUser[0],
                shiftId: shiftNow.id
            });
        }
    }, [shiftNow, ukmIdUser]);

    const handleChangePeriode = (event: SelectChangeEvent) => {
        setDateRange([new Date(event.target.value), new Date()]);
        setParamsListShift((prev) => ({
            ...prev,
            tglAwal: String(event.target.value),
            tglAkhir: nowShift,
            page: 1,
        }));

        refetchListShift();
    };

    const handleChangeJangkaWaktu = (
        tglAwal: string,
        tglAkhir: string,
    ) => {
        setParamsListShift((prev) => ({
            ...prev,
            tglAwal: tglAwal,
            tglAkhir: tglAkhir,
            page: 1,
        }));

        refetchListShift();
    };

    const [kasAwal, setKasAwal] = useState<number>(0);
    
    const startShift = async () => {
        try {
            const body = {
                ukmId: ukmId,
                userId: user?.userId,
                kasAwal: kasAwal,
            };
            console.log(body);
            const { data } = await axios.post(`/api/shift-start`, body);
            if (data.code === 200) {
                Swal.fire({
                    title: "Shift telah diperbarui",
                    position: "top-end",
                    showConfirmButton: false,
                    icon: "success",
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    showCloseButton: true,
                    customClass: {
                        container: "my-swal",
                    },
                });
            }
            refetchShiftNow();
        } catch (error) {
            console.error(error);
        }
    };

    function subtractYears(numOfYears: number, date = new Date()) {
        date.setFullYear(date.getFullYear() - numOfYears);

        return date;
    }

    const initialParamsUkm = {
        size: 500,
        page: 1,
        search: "",
    };
    const { data: ukm, status: statusUkm } = useUkm(initialParamsUkm);
    const { data: time } = useTimeAlt();

    const [sectionNumber, setSectionNumber] = useState(0);
    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setSectionNumber(newValue);
    };

    var today = new Date();

    const ukmId = React.useMemo(() => {
        if (user?.userId) {
            return getLocalUkmId(user?.userId);
        }
        return null;
    }, [user?.userId]);

    const ukmData = React.useMemo(() => {
        if (ukmId) {
            return ukm?.content.find((li) => li.id === ukmId);
        }
        return ukm?.content[0];
    }, [ukm?.content, ukmId]);

    useEffect(() => {
        scrollToHash();
    }, []);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const queryUkmId = urlParams.get("redirect");

    useEffect(() => {
        if (queryUkmId) {
            user?.userId && setLocalUkmId(user?.userId, Number(queryUkmId));
        }
    }, [queryUkmId, user?.userId]);

    useEffect(() => {
        if (queryUkmId && user && ukm && Number(queryUkmId) !== ukmId) {
            // window.location.reload();
            window.location.replace("/transaksi");
        } else if (queryUkmId && user && ukm && Number(queryUkmId) === ukmId) {
            window.location.replace("/transaksi");
        }
    }, [queryUkmId, ukm, ukmId, user]);

    const isSudahJatuhTempo = moment(time?.dateTime).isAfter(
        ukmData?.pembayaranBerikutnya,
    );

    if (
        statusUser === "loading" ||
        statusUkm === "loading" ||
        // statusTime === "loading" ||
        (queryUkmId && Number(queryUkmId) !== ukmId)
    ) {
        return (
            <Box
                position="relative"
                height={isLaptopScreen ? "100vh" : "calc(100vh - 56px)"}
            >
                <Spinner />
            </Box>
        );
    }

    if (user?.aksesTransaksi === 0 || user?.aksesTransaksi === null) {
        return <TokoTidakAktif label="Anda tidak memiliki akses halaman ini" />;
    }

    if (
        ukmData &&
        (ukmData?.isActive === 0 ||
            ukmData?.isActive === null ||
            ukmData?.lewatTempoPro === 1 ||
            isSudahJatuhTempo)
    ) {
        return <TokoTidakAktif namaToko={ukmData.namaToko} />;
    }

    
    return (
        <Box bgcolor="#ffffff">
            <Grid container minHeight="100dvh">
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    sx={{
                        overflowY: "scroll",
                        paddingRight: "10px",
                        position: "relative",
                    }}
                >
                    <Typography fontSize={32} fontWeight={700} mb={2} mt={1}>
                        Shift Saat Ini
                    </Typography>

                    {(shiftNow?.mulaiShift == null) ? (
                        <>
                            <Box>
                                <Card
                                    variant="outlined"
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        paddingY: 2,
                                        width: "100%",
                                        mb: 2,
                                    }}
                                >
                                    <Box display="flex" alignItems="center" marginLeft={3}>
                                        <Box justifyContent="space-between">
                                            <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                                <Typography variant="subtitle2">Kasir</Typography>
                                            </Stack>
                                            <Typography fontSize={18} fontWeight="bold">
                                                {String(user?.namaLengkap)}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Card>

                                <Typography fontSize={18} fontWeight={500}>
                                    Kas Awal
                                </Typography>

                                <NumberFormat
                                    value={kasAwal === null ? '' : kasAwal}
                                    inputMode="numeric"
                                    customInput={TextField}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    fullWidth
                                    placeholder="Masukan kas awal, Contoh 100.000"
                                    allowNegative={false}
                                    onChange={(
                                        event: React.ChangeEvent<HTMLInputElement>,
                                    ) => {
                                        setKasAwal(
                                            +event.target.value.replace(/\./g, ""),
                                        );
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Typography
                                                    variant="h6"
                                                    fontWeight="bold"
                                                >
                                                    Rp.
                                                </Typography>
                                            </InputAdornment>
                                        ),
                                    }}
                                    inputProps={{
                                        inputMode: "numeric",
                                        style: {
                                            fontSize: 16,
                                            fontWeight: "bold",
                                            textAlign: "left",
                                        },
                                    }}
                                    sx={{
                                        marginTop: 1,
                                        marginBottom: 2,
                                    }}
                                />
                            </Box>

                            <Box 
                                sx={{
                                    width: "95%",
                                    position:
                                        "absolute",
                                    bottom: "100px",
                                    zIndex: 1,
                                }}
                            >
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <LoadingButton
                                        variant="contained"
                                        onClick={startShift}
                                        size={isTabletScreen ? "small" : "large"}
                                        disabled={kasAwal === null}
                                        fullWidth
                                    >
                                        Mulai Shift
                                    </LoadingButton>
                                </Stack>
                            </Box>
                        </>
                    ) : (
                        <>
                            <Box>
                                <Card
                                    variant="outlined"
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        paddingY: 1,
                                        width: "100%",
                                        mb: 2,
                                    }}
                                >
                                    <Grid container marginLeft={3}>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <Typography variant="subtitle2">Kasir</Typography>
                                            <Typography fontSize={18} fontWeight="600">
                                                {shiftNow.kasir.nama}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={6}>
                                            <Typography variant="subtitle2">Mulai Shift</Typography>
                                            <Typography fontSize={18} fontWeight="600">
                                                {moment(shiftNow.mulaiShift).format("DD MMMM YYYY HH:mm")}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Card>
                    
                                <Grid container gap={1}>
                                    <Grid item xs={12} sm={12} md={5.9}>
                                        <CardLaporanShift
                                            namaCard="Kas Awal"
                                            isiCard={toRupiah(
                                                shiftNow.kasAwal
                                            )}
                                            icon={
                                                <Icon
                                                    path={mdiCash}
                                                    color={textPrimary.light}
                                                    size={1.5}
                                                    style={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                    }}
                                                />
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={5.9}>
                                        <CardLaporanShift
                                            namaCard="Pendapatan"
                                            isiCard={toRupiah(
                                                shiftNow.pendapatan
                                            )}
                                            icon={
                                                <Icon
                                                    path={mdiCash}
                                                    color={textPrimary.light}
                                                    size={1.5}
                                                    style={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                    }}
                                                />
                                            }
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={5.9}>
                                        <CardLaporanShift
                                            namaCard="Pengeluaran"
                                            isiCard={toRupiah(
                                                shiftNow.pengeluaran
                                            )}
                                            icon={
                                                <Icon
                                                    path={mdiCash}
                                                    color={textPrimary.light}
                                                    size={1.5}
                                                    style={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                    }}
                                                />
                                            }
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={5.9}>
                                        <CardLaporanShift
                                            namaCard="Kas Akhir"
                                            isiCard={toRupiah(shiftNow.kasAkhir ?? 0)}
                                            icon={
                                                <Icon
                                                    path={mdiCash}
                                                    color={textPrimary.light}
                                                    size={1.5}
                                                    style={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                    }}
                                                />
                                            }
                                        />
                                    </Grid>
                                </Grid>

                                <Box 
                                    sx={{
                                        width: "95%",
                                        position:
                                            "absolute",
                                        bottom: "100px",
                                        zIndex: 1,
                                    }}
                                >
                                    <Stack direction="row" spacing={2} alignItems="center">
                                        <LoadingButton
                                            variant="contained"
                                            onClick={() => {
                                                setIsOpenModalEndShift(true);
                                            }}
                                            size={isTabletScreen ? "small" : "large"}
                                            fullWidth
                                        >
                                            Akhiri Shift
                                        </LoadingButton>
                                    </Stack>
                                </Box>
                            </Box>
                        </>
                    )}

                
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    // md={isTabletScreen ? 6.5 : isCardView ? 5 : 6}
                    md={ 6}
                    sx={{
                        borderLeft: isPhoneScreen
                            ? undefined
                            : "1px solid rgba(0, 0, 0, 0.12)",
                        borderRight: isPhoneScreen
                            ? undefined
                            : "1px solid rgba(0, 0, 0, 0.12)",
                    }}
                >
                        <Box
                            sx={{
                                paddingLeft: 2,
                                borderColor: "divider",
                            }}
                        >
                            <Tabs
                                value={sectionNumber}
                                onChange={handleChange}
                                aria-label="Keranjang dan Daftar Transaksi"
                                variant="scrollable"
                                scrollButtons="auto"
                                allowScrollButtonsMobile
                            >
                                <Tab label="Riwayat Shift" {...a11yProps(0)} />
                                <Tab label="Daftar Transaksi" {...a11yProps(1)} />
                            </Tabs>
                        </Box>
                        {sectionNumber === 0 && (
                            <Grid container alignItems="center" gap={3} m={2}>
                                <Grid item xs={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={"auto"}>
                                            <Select
                                                value={
                                                    paramsListShift.tglAwal ===
                                                        nowShift ||
                                                    paramsListShift.tglAwal ===
                                                        moment()
                                                            .subtract(7, "days")
                                                            .format("YYYY-MM-DD") ||
                                                    paramsListShift.tglAwal ===
                                                        moment()
                                                            .subtract(1, "month")
                                                            .format("YYYY-MM-DD") ||
                                                    paramsListShift.tglAwal ===
                                                        moment()
                                                            .subtract(3, "months")
                                                            .format("YYYY-MM-DD") ||
                                                    paramsListShift.tglAwal ===
                                                        moment()
                                                            .subtract(1, "years")
                                                            .format("YYYY-MM-DD")
                                                        ? paramsListShift.tglAwal
                                                        : "Custom"
                                                }
                                                size="medium"
                                                sx={{ borderRadius: 2, width: 264 }}
                                                fullWidth
                                                onChange={handleChangePeriode}
                                            >
                                                <MenuItem value={nowShift}>
                                                    Hari ini
                                                </MenuItem>
                                                <MenuItem
                                                    value={moment()
                                                        .subtract(7, "days")
                                                        .format("YYYY-MM-DD")}
                                                >
                                                    1 Minggu Terakhir
                                                </MenuItem>
                                                <MenuItem
                                                    value={moment()
                                                        .subtract(1, "month")
                                                        .format("YYYY-MM-DD")}
                                                >
                                                    1 Bulan Terakhir
                                                </MenuItem>
                                        
                                                <MenuItem
                                                    value={"Custom"}
                                                    sx={{ display: "none" }}
                                                >
                                                    Custom
                                                </MenuItem>
                                            </Select>
                                        </Grid>
                                        <Grid item xs={"auto"}>
                                            <DatePicker
                                                className="range-filter"
                                                dateFormat="dd/MM/yyyy"
                                                disabledKeyboardNavigation
                                                onFocus={(e) => e.target.blur()}
                                                selectsRange={true}
                                                startDate={startDate}
                                                endDate={endDate}
                                                onChange={(update) => {
                                                    setDateRange(update);
                                                    if (update[1]) {
                                                        handleChangeJangkaWaktu(
                                                            moment(
                                                                update[0],
                                                            ).format("YYYY/MM/DD"),
                                                            moment(
                                                                update[1],
                                                            ).format("YYYY/MM/DD"),
                                                        );
                                                    }
                                                }}
                                                maxDate={today}
                                                minDate={subtractYears(1)}
                                                monthsShown={isPhoneScreen ? 1 : 2}
                                                customInput={
                                                    <Stack
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        direction="row"
                                                        width="100%"
                                                        bgcolor="#FFFF"
                                                        height="40px"
                                                        sx={{
                                                            border: "1px solid #cbcbcb",
                                                            borderRadius: "8px",
                                                            alignItems: "center",
                                                            paddingY: 3.4,
                                                            paddingX: 2,
                                                            width: 264,
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <Typography>
                                                            {moment(
                                                                paramsListShift.tglAwal,
                                                            ).format(
                                                                "DD/MM/YYYY",
                                                            )}{" "}
                                                            -{" "}
                                                            {paramsListShift.tglAkhir &&
                                                                moment(
                                                                    paramsListShift.tglAkhir,
                                                                ).format(
                                                                    "DD/MM/YYYY",
                                                                )}
                                                        </Typography>
                                                        <ExpandMoreIcon
                                                            sx={{
                                                                marginRight: "-9px",
                                                                color: "#757575",
                                                            }}
                                                        />
                                                    </Stack>
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {listShift?.content.map((li) => (
                                    <Grid item xs={12}>
                                        <Stack marginRight="15px" marginLeft="-15px">
                                            <Typography 
                                                fontWeight={500} 
                                                sx={{
                                                    padding: "10px 0 10px 10px",
                                                    color: "#2D312F",
                                                    backgroundColor: `rgba(${hexToRgb(ukmData?.warna)}, 0.2)`,
                                                }}
                                            >
                                                {moment(li.tanggal).format("DD MMMM YYYY HH:mm")}
                                            </Typography>

                                            {li.listShift.map((li) => (
                                                <>
                                                    <CardShift
                                                        shiftId={li.id}
                                                        kasir={li.kasir}
                                                        mulaiShift={li.mulaiShift}
                                                        akhirShift={li.akhirShift}
                                                    />
                                                </>
                                            ))}

                                            <Divider />
                                        </Stack>
                                    </Grid>
                                    
                                ))}
                            </Grid>
                        )}

                        {sectionNumber === 1 && (
                            <Grid container>
                                <Grid item xs={12}>
                                    <Stack>
                                        <Box 
                                            sx={{
                                                padding: "20px 0 20px 20px",
                                                mt: 2,
                                                backgroundColor: `rgba(${hexToRgb(ukmData?.warna)}, 0.2)`,
                                            }}
                                        >
                                            <Stack
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                            >
                                                <Typography
                                                    fontSize={18}
                                                >
                                                    Kasir
                                                </Typography>

                                                <Typography
                                                    color={textPrimary.title}
                                                    fontWeight={600}
                                                    fontSize={20}
                                                    mr={2}
                                                >
                                                    {listTransactionShift?.infoShift.kasir.nama || "-"}
                                                </Typography>
                                                
                                            </Stack>

                                            <Stack
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                            >
                                                <Typography
                                                    fontSize={18}
                                                >
                                                    Tanggal
                                                </Typography>

                                                <Typography
                                                    color={textPrimary.title}
                                                    fontWeight={600}
                                                    fontSize={20}
                                                    mr={2}
                                                >
                                                    {now}
                                                </Typography>
                                            </Stack>

                                            <Stack
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                            >
                                                <Typography
                                                    fontSize={18}
                                                >
                                                    Total Transaksi
                                                </Typography>

                                                <Typography
                                                    color={textPrimary.title}
                                                    fontWeight={600}
                                                    fontSize={20}
                                                    mr={2}
                                                >
                                                    {listTransactionShift?.totalElements || 0}
                                                </Typography>
                                                
                                            </Stack>
                                            
                                        </Box>
                                        

                                        <Grid container spacing={2} sx={{ p: 2 }}>
                                            <Grid item xs={12} container spacing={1} alignItems="center">
                                                {listTransactionShift?.content.map((li) => (
                                                    <React.Fragment key={li.id}>
                                                        <Grid item xs={12}>
                                                            <Typography variant="body1">
                                                                {moment(li.tanggal).format("DD MMMM YYYY HH:mm")}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Stack
                                                                direction="row"
                                                                justifyContent="space-between"
                                                                alignItems="center"
                                                            >
                                                                <Typography fontSize={18}>
                                                                    {li.keterangan}
                                                                </Typography>

                                                                {li.nominal >= 0 ? (
                                                                    <Typography
                                                                        color="#119C5B"
                                                                        fontWeight={600}
                                                                        fontSize={20}
                                                                        mr={1}
                                                                    >
                                                                        + {toRupiah(li.nominal)}
                                                                    </Typography>
                                                                ) : (
                                                                    <Typography
                                                                        color="#ED4521"
                                                                        fontWeight={600}
                                                                        fontSize={20}
                                                                        mr={1}
                                                                    >
                                                                        - {toRupiah(Math.abs(li.nominal))}
                                                                    </Typography>
                                                                )}
                                                            </Stack>
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Divider />
                                                        </Grid>
                                                    </React.Fragment>
                                                ))}
                                            </Grid>
                                        </Grid>
                                    </Stack>
                                </Grid>
                            </Grid>
                        )}
                </Grid> 
            </Grid>

            <ModalEndShift
                fullScreen={fullScreen}
                isOpenModalEndShift={isOpenModalEndShift}
                closeModalEndShift={closeModalEndShift}
            />
        </Box>
    );
};

export default Shifting;
